/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   phone number validator
 */

import * as Yup from 'yup'

const ERROR_PHONE = 'Please enter a valid phone number'

export const phoneValidatorOptional = Yup.string().matches(/^\(\d{3}\) \d{3}-\d{4}/, ERROR_PHONE)
export const phoneValidatorRequired = Yup.string()
  .required()
  .matches(/^\(\d{3}\) \d{3}-\d{4}/, ERROR_PHONE)
